import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template';
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {imageWidget_template} from "./imageWidget_template";
import {imagePicker_template} from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import {imagePickerHelper} from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";

declare var ko: any;

export class discountsEdit_template extends vnTemplate {

    protected validationsList: validationsList_template;
    public merchantSelector: filterAutocomplete_template;
    protected redemptionTypeSelector: filterDropdown_template;
    protected dealTypeSelector: filterDropdown_template;
    protected categorySelector: multipleSelector_template;
    protected branchSelector: multipleSelector_template;
    public imageWidgetForDiscount: imageWidget_template;
    public imageWidgetForLogo: imageWidget_template;
    public imagePicker: imagePicker_template;
    public imagePickerHelper: imagePickerHelper;

    protected imagePickerTarget: string = null;

    public static REDEMPTION_TYPES = [
        {id: 'online', name: 'Online Only'},
        {id: 'in-store', name: 'In-Store Only'},
        {id: 'both', name: 'Online & In-Store'}
    ];

    public static DEAL_TYPES = [
        {id: 'link', name: 'Link to Website'},
        {id: 'coupon', name: 'Coupon Code'}
    ];

    protected getTemplateHtml(): string {
        return /* html */`
            ${this.validationsList.getHtmlBuild()}
            <div class="form-header">
                <input type="hidden">

                <!-- ko ifnot: id() -->
                <h3 class="form-title icon i-discount">New Discount</h3>
                <!-- /ko -->

                <!-- ko if: id() -->
                <h3 class="form-title icon i-discount" data-bind="text: name"></h3>
                <!-- /ko -->

                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
            </div>

            <div class="form-pagination">
                <button class="icon" type="button" data-bind="event: { click: onClickTab.bind($data,'basic') }, css: { 'is-activated' : selectedTab() == 'basic'}"><span class="btn-text">Basic Info</span></button>
                <button class="icon" type="button" data-bind="event: { click: onClickTab.bind($data,'redemption') }, css: { 'is-activated' : selectedTab() == 'redemption'}"><span class="btn-text">Redemption</span></button>
                <button class="icon" type="button" data-bind="event: { click: onClickTab.bind($data,'contact') }, css: { 'is-activated' : selectedTab() == 'contact'}"><span class="btn-text">Contact & Advanced</span></button>
            </div>

            <!-- Basic Info Tab -->
            <div class="w-tabs-content
            " data-bind="css: { 'is-showing' : selectedTab() == 'basic'}">

                <div class="w-form-body">
                    <div class="form-body full-width">
                        <strong class="form-sub-title">Basic Information</strong>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Discount Headline / Name <span class="required">*</span></label>
                            <input data-bind="textInput: name" class="input-text" placeholder="Enter discount headline"/>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Slug</label>
                            <input data-bind="textInput: slug" class="input-text" placeholder="discount-slug"/>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Merchant / Company <span class="required">*</span></label>
                            ${this.merchantSelector.getHtmlBuild()}
                        </div>

                        <div class="form-group">
                            <div class="form-check">
                                <input type="checkbox" id="isActive" data-bind="checked: isActive">
                                <label class="form-label icon i-check" for="isActive">Active</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Discount Image</label>
                            <p class="form-hint">Optional image shown for this discount. If none is selected, the merchant logo will still be used where applicable.</p>
                            <div id="discount_image"></div>
                            ${this.imageWidgetForDiscount.getHtmlBuild()}
                        </div>
                    </div>

                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Short Description (Blurb)</label>
                            <textarea data-bind="value: blurb" class="input-text" rows="3" placeholder="Brief description of the discount"></textarea>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Full Description</label>
                            <textarea id="discount-description-editor" data-bind="value: description" class="input-text" rows="6" placeholder="Detailed description"></textarea>
                        </div>

                        <div class="form-group">
                            <label class="form-label icon i-lock">Logo (from merchant)</label>
                            <p class="form-hint">Read-only — the logo is associated with the merchant. Edit the merchant to change it.</p>
                            <div id="discount_logo"></div>
                            ${this.imageWidgetForLogo.getHtmlBuild()}
                        </div>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body full-width">
                        <strong class="form-sub-title">Categories & Availability</strong>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Discount Categories</label>
                            ${this.categorySelector.getHtmlBuild()}
                            <div id="selected-categories" class="tags-container"></div>
                        </div>
                    </div>

                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Available To (Military Branches)</label>
                            ${this.branchSelector.getHtmlBuild()}
                            <div id="selected-branches" class="tags-container"></div>
                        </div>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Redemption Location</label>
                            ${this.redemptionTypeSelector.getHtmlBuild()}
                        </div>
                    </div>

                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Start Date (optional)</label>
                            <input type="date" data-bind="value: startDate" class="input-text"/>
                        </div>

                        <div class="form-group">
                            <label class="form-label">End Date (optional)</label>
                            <input type="date" data-bind="value: endDate" class="input-text"/>
                        </div>

                        <div class="form-group" data-bind="visible: endDate()">
                            <label class="form-label">Expired Message</label>
                            <input data-bind="textInput: expiredMessage" class="input-text" placeholder="Message shown when discount expires"/>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Redemption Tab -->
            <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'redemption'}">
                <div class="w-form-body">
                    <div class="form-body full-width">
                        <strong class="form-sub-title">Redemption Details</strong>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Deal Type</label>
                            ${this.dealTypeSelector.getHtmlBuild()}
                        </div>

                        <div class="form-group" data-bind="visible: dealType() == 'coupon'">
                            <label class="form-label">Coupon Code</label>
                            <input data-bind="textInput: couponCode" class="input-text" placeholder="Enter coupon code"/>
                        </div>

                        <div class="form-group" data-bind="visible: dealType() == 'link' || dealType() == 'coupon'">
                            <label class="form-label">Business Website URL</label>
                            <input data-bind="textInput: redemptionOnlineUrl" class="input-text" placeholder="https://example.com/discount"/>
                        </div>

                        <div class="form-group" data-bind="visible: dealType() == 'link' || dealType() == 'coupon'">
                            <label class="form-label">Button Label</label>
                            <input data-bind="textInput: redemptionOnlineLabel" class="input-text" placeholder="Get Discount"/>
                        </div>
                    </div>

                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">GAM Sidebar Tracker URL</label>
                            <input data-bind="textInput: gamSidebarTrackerUrl" class="input-text" placeholder="https://example.com/sidebar-tracker"/>
                        </div>

                        <div class="form-group">
                            <label class="form-label">GAM Featured Tracker URL</label>
                            <input data-bind="textInput: gamFeaturedTrackerUrl" class="input-text" placeholder="https://example.com/featured-tracker"/>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Contact & Advanced Tab -->
            <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'contact'}">
                <div class="w-form-body">
                    <div class="form-body full-width">
                        <strong class="form-sub-title">Business Contact (Internal - Not Published)</strong>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Contact Name</label>
                            <input data-bind="textInput: contactName" class="input-text" placeholder="Contact person name"/>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Contact Email</label>
                            <input type="email" data-bind="textInput: contactEmail" class="input-text" placeholder="contact@company.com"/>
                        </div>
                    </div>

                    <div class="form-body">
                    </div>
                </div>
            </div>

            <!-- Form Actions -->
            <div class="form-footer">
                <button data-bind="event: { click: onClickCancel }" class="btn border" type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save Discount</button>
            </div>

            ${this.imagePicker.getHtmlBuild()}
        `;
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("validationsList", this.getTemplateViewModel(), this.caller);

        this.merchantSelector = new filterAutocomplete_template("merchantSelector", this.getTemplateViewModel(), this.caller);
        this.merchantSelector.setPlaceholderAndLabel('Merchant');
        this.merchantSelector.setNumberOfChars(1);
        this.merchantSelector.setAddNewOptionEnabled(false);
        this.merchantSelector.setHasDisplayNameComplement(false);

        this.redemptionTypeSelector = new filterDropdown_template("redemptionTypeSelector", this.getTemplateViewModel(), this.caller);
        this.redemptionTypeSelector.setLabel('Select Redemption Type');
        this.redemptionTypeSelector.setOptions(discountsEdit_template.REDEMPTION_TYPES);

        this.dealTypeSelector = new filterDropdown_template("dealTypeSelector", this.getTemplateViewModel(), this.caller);
        this.dealTypeSelector.setLabel('Select Deal Type');
        this.dealTypeSelector.setOptions(discountsEdit_template.DEAL_TYPES);

        this.categorySelector = new multipleSelector_template("categorySelector", this.getTemplateViewModel(), this.caller);
        this.categorySelector.setLabel('Select Categories');
        this.categorySelector.setFilterContainerClass('margin-neg');
        this.categorySelector.setTagContainerId('selected-categories');
        this.categorySelector.setTagContainerCaption('Selected Categories:');

        this.branchSelector = new multipleSelector_template("branchSelector", this.getTemplateViewModel(), this.caller);
        this.branchSelector.setLabel('Select Branches');
        this.branchSelector.setFilterContainerClass('margin-neg');
        this.branchSelector.setTagContainerId('selected-branches');
        this.branchSelector.setTagContainerCaption('Selected Branches:');

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller
        );

        this.imageWidgetForDiscount = new imageWidget_template("discount_image", this.getTemplateViewModel(), this);
        this.imageWidgetForDiscount.setMode('single-select');
        this.imageWidgetForDiscount.setCaller(this.imagePickerHelper);

        this.imageWidgetForLogo = new imageWidget_template("discount_logo", this.getTemplateViewModel(), this);
        this.imageWidgetForLogo.setMode('single-select');
        this.imageWidgetForLogo.setCaller(this.imagePickerHelper);
        this.imageWidgetForLogo.setIsGlobalLockEnabled(true); // Read-only: image is on merchant
    }

    protected getTemplateName(): string {
        return "discountsEdit_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): string[] {
        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            id: ko.observable(null),
            name: ko.observable(''),
            slug: ko.observable(''),
            blurb: ko.observable(''),
            description: ko.observable(''),
            merchantId: ko.observable(null),
            isActive: ko.observable(true),
            redemptionType: ko.observable('online'),
            dealType: ko.observable('link'),
            couponCode: ko.observable(''),
            redemptionOnlineUrl: ko.observable(''),
            redemptionOnlineLabel: ko.observable(''),
            gamSidebarTrackerUrl: ko.observable(''),
            gamFeaturedTrackerUrl: ko.observable(''),
            discountImageId: ko.observable(null),
            discountImageUrl: ko.observable(''),
            imageId: ko.observable(null),
            logoImageUrl: ko.observable(''),
            startDate: ko.observable(''),
            endDate: ko.observable(''),
            expiredMessage: ko.observable(''),
            contactName: ko.observable(''),
            contactEmail: ko.observable(''),
            selectedTab: ko.observable('basic'),
            categories: ko.observableArray([]),
            branches: ko.observableArray([]),

            onClickTab: (tab, data, event) => {
                self.onClickTab(tab);
            },
            onClickSave: (data, event) => {
                self.onClickSave();
            },
            onClickCancel: (data, event) => {
                self.onClickCancel();
            }
        };
    }

    protected onClickTab(tab: string): void {
        this.getTemplateViewModel().selectedTab(tab);
    }

    protected onClickSave(): void {
        this.caller.save();
    }

    protected onClickCancel(): void {
        this.caller.cancel();
    }

    public clearMessages(): void {
        this.validationsList.clearMessages();
    }

    public setValidationMessages(messages): void {
        this.validationsList.setMessages(messages);
    }

    public setSingleValidationMessage(message): void {
        this.validationsList.setSingleMessage(message);
    }

    public getViewModelForRequest(): any {
        const vm = this.getTemplateViewModel();
        return {
            id: vm.id(),
            name: vm.name(),
            slug: vm.slug(),
            blurb: vm.blurb(),
            description: vm.description(),
            idMerchant: this.merchantSelector.getOptionObj() ? this.merchantSelector.getOptionObj().id : null,
            isActive: vm.isActive(),
            redemptionType: this.redemptionTypeSelector.getTemplateViewModel().selectedOption() || 'online',
            dealType: this.dealTypeSelector.getTemplateViewModel().selectedOption() || 'link',
            couponCode: vm.couponCode(),
            redemptionOnlineUrl: vm.redemptionOnlineUrl(),
            redemptionOnlineLabel: vm.redemptionOnlineLabel(),
            gamSidebarTrackerUrl: vm.gamSidebarTrackerUrl(),
            gamFeaturedTrackerUrl: vm.gamFeaturedTrackerUrl(),
            idImage: vm.discountImageId(),
            startDate: vm.startDate() || null,
            endDate: vm.endDate() || null,
            expiredMessage: vm.expiredMessage(),
            contactName: vm.contactName(),
            contactEmail: vm.contactEmail(),
            categoryIds: this.categorySelector.getSelectedItems(),
            branchIds: this.branchSelector.getSelectedItems()
        };
    }

    public setCategoryOptions(categories: any[]): void {
        this.categorySelector.setItems(categories);
    }

    public setBranchOptions(branches: any[]): void {
        this.branchSelector.setItems(branches);
    }

    public setMerchantSuggestions(options: any[]): void {
        this.merchantSelector.setOptions(options);
    }

    public setDiscountData(discount: any): void {
        const vm = this.getTemplateViewModel();

        vm.id(discount.id);
        vm.name(discount.name || '');
        vm.slug(discount.slug || '');
        vm.blurb(discount.blurb || '');
        vm.description(discount.description || '');
        vm.isActive(discount.isActive !== false);
        vm.couponCode(discount.couponCode || '');
        vm.redemptionOnlineUrl(discount.redemptionOnlineUrl || '');
        vm.redemptionOnlineLabel(discount.redemptionOnlineLabel || '');
        vm.gamSidebarTrackerUrl(discount.gamSidebarTrackerUrl || '');
        vm.gamFeaturedTrackerUrl(discount.gamFeaturedTrackerUrl || '');
        vm.startDate(discount.startDate ? discount.startDate.substring(0, 10) : '');
        vm.endDate(discount.endDate ? discount.endDate.substring(0, 10) : '');
        vm.expiredMessage(discount.expiredMessage || '');
        vm.contactName(discount.contactName || '');
        vm.contactEmail(discount.contactEmail || '');

        if (discount.discountImage) {
            this.setDiscountImage(discount.discountImage);
        } else {
            this.removeImage('discount_image');
        }

        // Set merchant — pre-populate autocomplete with name + image so the logo updates immediately
        if (discount.merchant) {
            this.merchantSelector.setOption({
                id:    discount.merchant.id,
                name:  discount.merchant.name,
                image: discount.merchant.image || null
            });
        }

        // Set redemption type
        if (discount.redemptionType) {
            this.redemptionTypeSelector.setSelectedOption(discount.redemptionType);
        }

        // Set deal type
        if (discount.dealType) {
            this.dealTypeSelector.setSelectedOption(discount.dealType);
        }

        // Set selected categories
        if (discount.categories && discount.categories.length > 0) {
            this.categorySelector.setSelectedItems(discount.categories);
            this.categorySelector.setTags(
                this.categorySelector.getSelectedItems(),
                this.categorySelector.getItems()
            );
        }

        // Set selected branches
        if (discount.branches && discount.branches.length > 0) {
            this.branchSelector.setSelectedItems(discount.branches);
            this.branchSelector.setTags(
                this.branchSelector.getSelectedItems(),
                this.branchSelector.getItems()
            );
        }

        // Logo is set automatically via onAutocompleteOptionChange when the merchant is pre-populated above.
    }

    public setDiscountImage(image: any): void {
        const vm = this.getTemplateViewModel();
        vm.discountImageId(image.id);
        vm.discountImageUrl(image.url);
        this.imageWidgetForDiscount.setImage(image);
    }

    public setLogoImage(image: any): void {
        const vm = this.getTemplateViewModel();
        vm.imageId(image.id);
        vm.logoImageUrl(image.url);
        this.imageWidgetForLogo.setImage(image);
    }

    public removeImage(target: string): void {
        const vm = this.getTemplateViewModel();
        if (target === 'discount_image') {
            vm.discountImageId(null);
            vm.discountImageUrl('');
            this.imageWidgetForDiscount.clearImage();
        } else if (target === 'discount_logo') {
            vm.imageId(null);
            vm.logoImageUrl('');
            this.imageWidgetForLogo.clearImage();
        }
    }

    public updateSelectedCategories(): void {
        // Categories are automatically updated via the multipleSelector
    }

    public updateSelectedBranches(): void {
        // Branches are automatically updated via the multipleSelector
    }

    public setImagePickerTarget(target: string): void {
        this.imagePickerTarget = target;
    }

    public getImagePickerTarget(): string {
        return this.imagePickerTarget;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/discountsEdit_template.ts